/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationSettingsResponse } from '../../models/notification-settings-response';

export interface GetNotificationSetting$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
  notificationType: 'SMS' | 'PUSH';
}

export function getNotificationSetting(http: HttpClient, rootUrl: string, params: GetNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotificationSetting.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('notificationType', params.notificationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationSettingsResponse>;
    })
  );
}

getNotificationSetting.PATH = '/tenants/{tenantId}/notification-settings/{notificationType}';
